import { push, ref } from "firebase/database";
import { database, auth } from "./firebase";
import { removeUndefinedValues } from "../util/util";

async function getElectronVersion() {
    try {
        if (typeof window !== "undefined" && window.electron && typeof window.electron.getAppVersion === "function") {
            return await window.electron.getAppVersion();
        }
    } catch (e) {
        console.error("Failed to get Electron version", e);
    }
    return null;
}

export async function logError(error, context = {}) {
    try {
        const userId = auth.currentUser ? auth.currentUser.uid : "anonymous";
        const date = new Date().toISOString().split("T")[0];
        const cleanContext = removeUndefinedValues(context);
        const logRef = ref(database, `/logs/${userId}/${date}/errors`);
        const environment = typeof window !== "undefined" && window.electron ? "electron" : "web";
        const appVersion = environment === "electron" ? await getElectronVersion() : null;
        push(logRef, {
            date,
            message: error && error.message ? error.message : String(error),
            stack: error && error.stack ? error.stack : null,
            context: cleanContext,
            environment,
            appVersion,
            url: typeof window !== "undefined" ? window.location.href : "",
            timestamp: new Date().toISOString(),
        });
    } catch (e) {
        console.error("Failed to log error", e);
    }
}

export async function logEvent(eventName, params = {}) {
    try {
        const userId = auth.currentUser ? auth.currentUser.uid : "anonymous";
        const date = new Date().toISOString().split("T")[0];
        const logRef = ref(database, `/logs/${userId}/${date}/events`);
        const cleanParam = removeUndefinedValues(params);
        const environment = typeof window !== "undefined" && window.electron ? "electron" : "web";
        const appVersion = environment === "electron" ? await getElectronVersion() : null;
        push(logRef, {
            date,
            eventName,
            params: cleanParam,
            environment,
            appVersion,
            url: typeof window !== "undefined" ? window.location.href : "",
            timestamp: new Date().toISOString(),
        });
    } catch (e) {
        console.error("Failed to log event", e);
    }
}